import type { HelpFile } from '../../types/help'
import { K8sConfigCardTestIds } from '../../../testids/K8sConfigCardTestIds'

export const k8sConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [K8sConfigCardTestIds.k8sConfigCard]:
      'Kubernetes connector configuration — API endpoint, namespace, and authentication used to apply provisioning changes against a cluster.',
    [K8sConfigCardTestIds.cardTitleK8sConfig]: null,
    [K8sConfigCardTestIds.btnCreateK8sConfig]: null,
    [K8sConfigCardTestIds.btnEditK8sConfig]: null,
    [K8sConfigCardTestIds.selectK8sAuthType]:
      'Authentication mechanism used to talk to the cluster — bearer token, kubeconfig context, or in-cluster service account.',
  },
}
